import { Button } from "@mui/material";
import { useState } from "react";
import EditQuestionCategoryModal from "../modals/EditQuestionCategoryModal";
import EditQuestionSubcategoryModal from "resources/questionCategory/list/components/EditQuestionSubcategoryModal";

interface CreateSubcategoryButtonProps {
    category?: { id: string; title: string };
}

const CreateSubcategoryButton = ({ category }: CreateSubcategoryButtonProps) => {
    const [openCreateSubcategoryCategoryModal, setOpenCreateSubcategoryCategoryModal] = useState<boolean>(false);
    const handleOpenCreateSubcategoryModal = () => setOpenCreateSubcategoryCategoryModal(true);
    const handleCloseCreateSubcategoryModal = () => setOpenCreateSubcategoryCategoryModal(false);

    return (
        <>
            <Button
                onClick={handleOpenCreateSubcategoryModal}
                sx={{ width: 'fit-content' }}>
                Создать подкатегорию
            </Button>
            {
                openCreateSubcategoryCategoryModal &&
                <EditQuestionSubcategoryModal
                    isOpen={openCreateSubcategoryCategoryModal}
                    onClose={handleCloseCreateSubcategoryModal}
                    category={category}
                />
            }
        </>
    )
}

export default CreateSubcategoryButton;
